function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.505838 10.9931C0.539672 11.0269 0.57985 11.0538 0.624076 11.0721C0.668301 11.0905 0.715706 11.0999 0.763581 11.0999C0.811456 11.0999 0.858861 11.0905 0.903087 11.0721C0.947312 11.0538 0.98749 11.0269 1.02132 10.9931L5.49858 6.51621L9.97766 10.9931C10.046 11.0614 10.1387 11.0998 10.2354 11.0998C10.3321 11.0998 10.4248 11.0614 10.4931 10.9931C10.5615 10.9247 10.5999 10.832 10.5999 10.7353C10.5999 10.6387 10.5615 10.546 10.4931 10.4776L6.01407 6.00077L10.4913 1.52209C10.5597 1.45374 10.5981 1.36104 10.5981 1.26437C10.5981 1.16771 10.5597 1.075 10.4913 1.00665C10.423 0.938302 10.3303 0.899902 10.2336 0.899902C10.1369 0.899902 10.0442 0.938302 9.97584 1.00665L5.49858 5.48533L1.0195 1.00847C0.949811 0.948798 0.860165 0.917614 0.76848 0.921156C0.676794 0.924697 0.589821 0.962702 0.524941 1.02758C0.460061 1.09245 0.422053 1.17942 0.418511 1.27109C0.41497 1.36277 0.446156 1.45241 0.505838 1.52209L4.98309 6.00077L0.505838 10.4794C0.437987 10.5477 0.399902 10.64 0.399902 10.7363C0.399902 10.8325 0.437987 10.9248 0.505838 10.9931Z",
  fill: "#0D183F"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.c6e53d0a.svg";
export { ForwardRef as ReactComponent };